module.exports = __webpack_public_path__ + "static/media/productBanner.e5a4d495.svg";